<template>
  <form @submit.prevent='controller.doSubmit()'>
    <div class="space-y-12 sm:space-y-16">
      <div>
        <div class="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
          <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6" v-for='field in fields'>
            <label :for="field.id" class="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{{ field.label }}</label>
            <div class="mt-2 sm:col-span-2 sm:mt-0">
              <Component :is='field.input' v-model='field.state.model' :labelId='field.id' :hideLabel='true' v-bind='field.props || {}' />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-6 flex items-center justify-end gap-x-6">
      <button type="button" class="text-sm font-semibold leading-6 text-gray-900" v-if='props.showCancel'>Cancel</button>
      <button type="submit" class="rounded-md bg-jananavy-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-jananavy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-jananavy-600 disabled:opacity-50 disabled:hover:bg-jananavy-900">
        {{ props.buttonLabel }}
      </button>
    </div>
  </form>
</template>

<script setup>

import { nanoid } from 'nanoid';

const props = defineProps({
  controller: Object,
  fields: Array,
  buttonLabel: String
});

const fields = props.fields.map((field) => {
  return {
    ...field,
    id: `_${nanoid()}`,
    state: props.controller.connectField(field.key, field.adapter)
  }
});

const state = props.controller.getState();

</script>